import { Facebook, Instagram, Linkedin, Twitter, Youtube, Mail } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <>
      <footer className="relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] w-screen bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 sm:pt-[80px] pb-8">
          {/* Main Footer Content - Logo + 5 Columns — spec: gap 40px */}
          <div className="flex flex-wrap lg:flex-nowrap items-start gap-10 lg:gap-16">
            {/* Column 1 - Brand Information */}
            <div className="w-full sm:w-[calc(50%-16px)] lg:w-auto lg:max-w-[320px] lg:flex-shrink-0">
              <Link to="/" className="inline-flex items-center gap-3 mb-4 cursor-pointer">
                <img
                  src="/logo-dark.svg"
                  alt="TeamGrid Logo"
                  width={220}
                  height={32}
                  className="flex-shrink-0"
                  style={{ objectFit: "contain", marginLeft: "-12px" }}
                />
              </Link>
              <p
                className="text-black"
                style={{ fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: 15, lineHeight: "26px", maxWidth: 320 }}
              >
                AI-powered team performance intelligence. Know what your team actually does.
              </p>
            </div>

            {/* Navigation Columns Container */}
            <div className="w-full lg:w-auto flex flex-wrap lg:flex-nowrap gap-12 lg:gap-16 xl:gap-20 items-start">
              {/* Column 2 - SOLUTIONS — spec: heading 14px 700 uppercase, links 15px 400 */}
              <div className="w-full sm:w-[calc(50%-24px)] lg:w-auto lg:flex-shrink-0">
                <h4 className="footer-col-head mb-4">
                  Solutions
                </h4>
                <ul className="space-y-2.5">
                  <li>
                    <a
                      href="/solutions/remote-team-productivity"
                      className="footer-link"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      Remote Teams
                    </a>
                  </li>
                  <li>
                    <a
                      href="/solutions/contract-freelance-teams"
                      className="footer-link"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      Contract Teams
                    </a>
                  </li>
                  <li>
                    <a
                      href="/solutions/client-driven-work"
                      className="footer-link"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      Client-Driven Teams
                    </a>
                  </li>
                  <li>
                    <a
                      href="/solutions/virtual-support-services"
                      className="footer-link"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      Virtual Services
                    </a>
                  </li>
                  <li>
                    <a
                      href="/solutions/bpo-shared-services"
                      className="footer-link"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      BPO & Shared Services
                    </a>
                  </li>
                  <li>
                    <a
                      href="/solutions/project-based-teams"
                      className="footer-link"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      Project-Based Teams
                    </a>
                  </li>
                  <li>
                    <a
                      href="/solutions/hr-staffing-firms"
                      className="footer-link"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      HR & Staffing Firms
                    </a>
                  </li>
                  <li>
                    <a
                      href="/solutions/accounting-firm-productivity"
                      className="footer-link"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      Accounting Firms
                    </a>
                  </li>
                  <li>
                    <a
                      href="/solutions/edtech-productivity-software"
                      className="footer-link"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      EdTech Teams
                    </a>
                  </li>
                </ul>
              </div>

              {/* Column 3 - FEATURES */}
              <div className="w-full sm:w-[calc(50%-24px)] lg:w-auto lg:flex-shrink-0">
                <h4 className="footer-col-head mb-4">
                  Features
                </h4>
                <ul className="space-y-2.5">
                  <li>
                    <a
                      href="/features/automatic-time-tracking"
                      className="footer-link"
                    >
                      Automatic Time Tracking
                    </a>
                  </li>
                  <li>
                    <a
                      href="/features/app-website-tracking"
                      className="footer-link"
                    >
                      App & Website Tracking
                    </a>
                  </li>
                  <li>
                    <a
                      href="/features/productivity-scoring"
                      className="footer-link"
                    >
                      Productivity Scoring
                    </a>
                  </li>
                  <li>
                    <a
                      href="/features/ai-work-summaries"
                      className="footer-link"
                    >
                      AI Work Summaries
                    </a>
                  </li>
                  <li>
                    <a
                      href="/features/team-management"
                      className="footer-link"
                    >
                      Team Management
                    </a>
                  </li>
                  <li>
                    <a
                      href="/features/hourly-breakdown"
                      className="footer-link"
                    >
                      Hourly Breakdown
                    </a>
                  </li>
                  <li>
                    <a
                      href="/features/project-tracking"
                      className="footer-link"
                    >
                      Project Tracking
                    </a>
                  </li>
                  <li>
                    <a
                      href="/features/org-intelligence"
                      className="footer-link"
                    >
                      Org Intelligence
                    </a>
                  </li>
                  <li>
                    <a
                      href="/features/ask-teamgrid"
                      className="footer-link"
                    >
                      Ask TeamGrid
                    </a>
                  </li>
                </ul>
              </div>

              {/* Column 4 - PRODUCT and COMPANY stacked */}
              <div className="w-full sm:w-[calc(50%-24px)] lg:w-auto lg:flex-shrink-0">
                {/* PRODUCT */}
                <div className="mb-8">
                  <h4 className="footer-col-head mb-4">
                    Product
                  </h4>
                  <ul className="space-y-2.5">
                    <li>
                      <a
                        href="/book-demo"
                        className="footer-link"
                      >
                        Book Demo
                      </a>
                    </li>
                    <li>
                      <Link
                        to="/download"
                        className="footer-link"
                      >
                        Download
                      </Link>
                    </li>
                    <li>
                      <a
                        href="/#pricing"
                        className="footer-link"
                      >
                        Pricing
                      </a>
                    </li>
                    <li>
                      <Link
                        to="/resource-optimizer"
                        className="footer-link"
                        style={{ color: "#00D1C1", fontWeight: 500 }}
                      >
                        Resource Optimizer
                      </Link>
                    </li>
                  </ul>
                </div>

                {/* COMPANY */}
                <div>
                  <h4 className="footer-col-head mb-4">
                    Company
                  </h4>
                  <ul className="space-y-2.5">
                    <li>
                      <a
                        href="/contact-us"
                        className="footer-link"
                      >
                        Contact
                      </a>
                    </li>
                    <li>
                      <a
                        href="/blog"
                        className="footer-link"
                      >
                        Blog
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Column 6 - RESOURCES */}
              <div className="w-full sm:w-[calc(50%-24px)] lg:w-auto lg:flex-shrink-0">
                <h4 className="footer-col-head mb-4">
                  Resources
                </h4>
                <ul className="space-y-2.5">
                  <li>
                    <a
                      href="/terms-of-service"
                      className="footer-link"
                    >
                      Terms of Service
                    </a>
                  </li>
                  <li>
                    <a
                      href="/privacy-policy"
                      className="footer-link"
                    >
                      Privacy Policy
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Contact Info bar — bg #F7F7F7 */}
          <div
            className="flex flex-col sm:flex-row items-center justify-center sm:justify-start gap-3 sm:gap-6 px-4 mt-10 py-4 sm:py-6 rounded-lg"
            style={{ background: "#F7F7F7" }}
          >
            <div className="flex items-center gap-2 sm:gap-3">
              <Mail className="w-5 h-5 flex-shrink-0" style={{ color: "#00D1C1" }} />
              <span className="text-black text-[15px] sm:text-[18px] leading-[24px] sm:leading-[36px]" style={{ fontFamily: "Inter", fontWeight: 400 }}>
                Sales:{" "}
                <a href="mailto:hello@teamgrid.ai" className="footer-link underline hover:opacity-80">
                  hello@teamgrid.ai
                </a>
              </span>
            </div>
            <div className="flex items-center gap-2 sm:gap-3">
              <Mail className="w-5 h-5 flex-shrink-0" style={{ color: "#00D1C1" }} />
              <span className="text-black text-[15px] sm:text-[18px] leading-[24px] sm:leading-[36px]" style={{ fontFamily: "Inter", fontWeight: 400 }}>
                Support:{" "}
                <a href="mailto:support@teamgrid.ai" className="footer-link underline hover:opacity-80">
                  support@teamgrid.ai
                </a>
              </span>
            </div>

            {/* B2B Partner Portal entry point — placed after Support */}
            <div className="flex items-center gap-2 sm:gap-3 mt-1">
              <Link
                to="/partner-login"
                className="inline-flex items-center gap-2 text-[14px] sm:text-[15px] font-semibold transition-colors duration-300"
                style={{ fontFamily: "Inter", color: "#0F766E" }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#00D1C1")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#0F766E")}
              >
                <span
                  className="inline-flex items-center justify-center w-5 h-5 rounded-full flex-shrink-0"
                  style={{ backgroundColor: "rgba(0,209,193,0.14)" }}
                >
                  <span
                    className="inline-block w-1.5 h-1.5 rounded-full"
                    style={{ backgroundColor: "#00D1C1" }}
                  />
                </span>
                TeamGrid for Partners — B2B Login
              </Link>
            </div>
          </div>

          {/* Bottom — spec: border-top 1px solid #000, copyright 14px, social gap 16px */}
          <div className="border-t pt-5 mt-0" style={{ borderTopColor: "#000000" }}>
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-black mb-0" style={{ fontFamily: "Inter", fontWeight: 400, fontSize: 14, lineHeight: "22px" }}>
                © 2026 TeamGrid. All rights reserved.
              </p>
              <div className="flex items-center gap-4" style={{ gap: 16 }}>
                <a
                  href="https://www.facebook.com/teamgridai"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-5 h-5 flex items-center justify-center text-[#111111] hover:text-[#28B4AE] transition-colors duration-300"
                >
                  <Facebook className="w-4 h-4" />
                </a>
                <a
                  href="https://youtu.be/H2qiGOXlwG8?si=NPwGnFTy-f1-rVMw"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-5 h-5 flex items-center justify-center text-[#111111] hover:text-[#28B4AE] transition-colors duration-300"
                >
                  <Youtube className="w-4 h-4" />
                </a>
                <a
                  href="https://www.instagram.com/teamgrid.ai/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-5 h-5 flex items-center justify-center text-[#111111] hover:text-[#28B4AE] transition-colors duration-300"
                >
                  <Instagram className="w-4 h-4" />
                </a>
                <a
                  href="https://www.linkedin.com/company/teamgridai/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-5 h-5 flex items-center justify-center text-[#111111] hover:text-[#28B4AE] transition-colors duration-300"
                >
                  <Linkedin className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
